<div
    class="d-flex preclarification-content align-items-center"
    (click)="toggle()"
    [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
>
    <fa-icon
        [icon]="isCollapsed ? faChevronRight : faChevronDown"
        aria-hidden="true"
        class="d-block d-lg-none me-3"
    ></fa-icon>
    <h3 class="m-0">{{ preclarificationLongtextTitle }}</h3>
</div>
<div *ngIf="!isCollapsed">
    <div
        class="user-select-auto mt-2"
        *ngFor="let text of preclarificationLongtext"
        paceCoreLink
        [innerHTML]="text.TextLine"
    ></div>
</div>
